import React from "react";
import { useHistory } from "react-router-dom";
import TopBar from "../components/slidesPage/SlidesPageTopBar/TopBar";
import SlidesContainer from "../components/slidesPage/SlidesContainer/SlidesContainer";
import FloatingActionButton from "../components/reusable/Button/FloatingActionButton";
import styles from "./SlidesPage.module.css";
import { createSlides } from "../helpers/api";
import Routes from "../routes.json";

const SlidesPage = () => {
	const history = useHistory();

	const handleClickFAC = async () => {
		try {
			let data = await createSlides();
			if (data) history.push(Routes.EditorPage + "/" + data.id);
		} catch (error) {}
	};

	return (
		<div className={styles.slidesPage}>
			<TopBar />
			<SlidesContainer />
			<FloatingActionButton
				leading="+"
				text="Create Slides"
				action={handleClickFAC}
			/>
		</div>
	);
};

export default SlidesPage;
